// extracted by mini-css-extract-plugin
export default {"footer":"dunwBxWOUtv3FjeCZxww","close":"G3G6rVAamJBT_sqlRpgk"};